let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("p89La"), load("cJccL")]).then(() => parcelRequire('ll9YW'));